import {createFileRoute} from '@tanstack/react-router'

import {RentalAssetsPage} from '../../../assets/rental-assets/rental-assets-page'

export const Route = createFileRoute('/_app/rental-assets/')({
    component: RentalAssetsIndexRoute,
})

function RentalAssetsIndexRoute() {
    return <RentalAssetsPage />
}
